"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExemptionLevels;
(function (ExemptionLevels) {
    ExemptionLevels[ExemptionLevels["Level_1"] = 1] = "Level_1";
    ExemptionLevels[ExemptionLevels["Level_2"] = 2] = "Level_2";
    ExemptionLevels[ExemptionLevels["Level_3"] = 3] = "Level_3";
    ExemptionLevels[ExemptionLevels["Level_4"] = 4] = "Level_4";
    ExemptionLevels[ExemptionLevels["Level_5"] = 5] = "Level_5";
    ExemptionLevels[ExemptionLevels["Level_6"] = 6] = "Level_6";
    ExemptionLevels[ExemptionLevels["Level_7"] = 7] = "Level_7";
})(ExemptionLevels = exports.ExemptionLevels || (exports.ExemptionLevels = {}));
var LevelName;
(function (LevelName) {
    LevelName["Level_1"] = "Cert BA";
    LevelName["Level_2"] = "Operational OT";
    LevelName["Level_3"] = "Operational CS";
    LevelName["Level_4"] = "Management OT";
    LevelName["Level_5"] = "Management CS";
    LevelName["Level_6"] = "Strategic OT";
    LevelName["Level_7"] = "Strategic CS";
})(LevelName = exports.LevelName || (exports.LevelName = {}));
var LevelNamePQ;
(function (LevelNamePQ) {
    LevelNamePQ["Level_1"] = "CIMA Certificate in Business Accounting (CIMA Cert BA)";
    LevelNamePQ["Level_2"] = "Operational Level";
    LevelNamePQ["Level_3"] = "Operational Level";
    LevelNamePQ["Level_4"] = "Management Level";
    LevelNamePQ["Level_5"] = "Management Level";
    LevelNamePQ["Level_6"] = "Strategic Level";
    LevelNamePQ["Level_7"] = "Strategic Level";
})(LevelNamePQ = exports.LevelNamePQ || (exports.LevelNamePQ = {}));
var LevelNameFLP;
(function (LevelNameFLP) {
    LevelNameFLP["Level_1"] = "Business and Finance Essentials";
    LevelNameFLP["Level_2"] = "Operational Level";
    LevelNameFLP["Level_3"] = "Operational Level";
    LevelNameFLP["Level_4"] = "Management Level";
    LevelNameFLP["Level_5"] = "Management Level";
    LevelNameFLP["Level_6"] = "Strategic Level";
    LevelNameFLP["Level_7"] = "Strategic Case Study Exam";
})(LevelNameFLP = exports.LevelNameFLP || (exports.LevelNameFLP = {}));
var LevelNameChinesePQ;
(function (LevelNameChinesePQ) {
    LevelNameChinesePQ["Level_1"] = "Business and Finance Essentials";
    LevelNameChinesePQ["Level_2"] = "Operational Level";
    LevelNameChinesePQ["Level_3"] = "Operational Level";
    LevelNameChinesePQ["Level_4"] = "Management Level";
    LevelNameChinesePQ["Level_5"] = "Management Level";
    LevelNameChinesePQ["Level_6"] = "Chinese Management Level";
    LevelNameChinesePQ["Level_7"] = "Chinese Strategic Level";
})(LevelNameChinesePQ = exports.LevelNameChinesePQ || (exports.LevelNameChinesePQ = {}));
var FLPLevels;
(function (FLPLevels) {
    FLPLevels["Level_1"] = "Level 1";
    FLPLevels["Level_2"] = "Level 2";
    FLPLevels["Level_3"] = "Level 3";
    FLPLevels["Level_4"] = "Level 4";
    FLPLevels["Level_5"] = "Level 5";
    FLPLevels["Level_6"] = "Level 6";
    FLPLevels["Level_7"] = "Level 7";
})(FLPLevels = exports.FLPLevels || (exports.FLPLevels = {}));
var ExemptionFormType;
(function (ExemptionFormType) {
    ExemptionFormType["PROFESSIONAL_BODIES"] = "Professional_Bodies";
    ExemptionFormType["QUALIFICATION"] = "Qualification";
    ExemptionFormType["PROFESSIONAL_BACKGROUND"] = "Professional_Background";
})(ExemptionFormType = exports.ExemptionFormType || (exports.ExemptionFormType = {}));
var USCpaExamEnum;
(function (USCpaExamEnum) {
    USCpaExamEnum["NOT_PASSED_US_CPA_EXAM"] = "No, I'm not";
    USCpaExamEnum["YES_NOT_YET_LICENSED"] = "Yes, and I am not yet licensed";
    USCpaExamEnum["YES_LICENSED_BEFORE"] = "Yes, and I have been licensed before";
})(USCpaExamEnum = exports.USCpaExamEnum || (exports.USCpaExamEnum = {}));
var QualificationName;
(function (QualificationName) {
    QualificationName["Cert"] = "CIMA Certificate in Business Accounting (CIMA Cert BA)";
    QualificationName["Business"] = "Business and Finance Essentials Course";
    QualificationName["Operational"] = "Operational Level";
    QualificationName["Management"] = "Management Level";
    QualificationName["Strategic"] = "Strategic Level";
})(QualificationName = exports.QualificationName || (exports.QualificationName = {}));
//# sourceMappingURL=index.js.map